import { ChartDataItem, ChartTreeDataItem } from './chart.models';

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

function chartValue(value: unknown): number {
  if (!(typeof value === 'number' || (typeof value === 'string' && value.trim() !== '')) ||
    !Number.isFinite(Number(value)) || Number(value) < 0) {
    throw new Error('Invalid chart value');
  }
  return Number(value);
}

export function parseCategoryChartData(data: unknown): ChartDataItem[] {
  if (!Array.isArray(data)) throw new Error('Invalid chart data');
  return data.map(item => {
    if (!isRecord(item) || !(typeof item.X === 'string' || (typeof item.X === 'number' && Number.isFinite(item.X)))) {
      throw new Error('Invalid chart label');
    }
    return { name: String(item.X), value: chartValue(item.Y) };
  });
}

export function parseChartTree(data: unknown): ChartTreeDataItem[] {
  if (Array.isArray(data) && data.length === 0) return [];
  function node(value: unknown): ChartTreeDataItem {
    if (!isRecord(value) || typeof value.name !== 'string' ||
      (value.children !== undefined && !Array.isArray(value.children))) {
      throw new Error('Invalid tree node');
    }
    return {
      name: value.name,
      ...(value.value !== undefined && value.value !== null ? { value: chartValue(value.value) } : {}),
      ...(Array.isArray(value.children) ? { children: value.children.map(node) } : {}),
    };
  }
  const root = node(data);
  return root.children?.length || (root.value !== undefined && root.value > 0) ? [root] : [];
}
